<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <!-- <div v-show="$route.path == '/Report/BrandCount'" class="kt-portlet kt-portlet--mobile"> -->
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form
            autocomplete="off"
            class="kt-form"
            ref="form"
            @submit.prevent="formSubmit($event)"
          >
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่ส่ง(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reBcTransferJobCommitDateStart"
                      name="reBcTransferJobCommitDateStart"
                      ref="reBcTransferJobCommitDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่ส่ง(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reBcTransferJobCommitDateEnd"
                      name="reBcTransferJobCommitDateEnd"
                      ref="reBcTransferJobCommitDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group ">
                  <label class="label">วันที่รับ(เริ่มต้น):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reBcRetrieveJobCommitDateStart"
                      name="reBcRetrieveJobCommitDateStart"
                      ref="reBcRetrieveJobCommitDateStart"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label class="label">วันที่รับ(สิ้นสุด):</label>
                  <div class="input-group date">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="(วว/ดด/ปปปป)"
                      id="reBcRetrieveJobCommitDateEnd"
                      name="reBcRetrieveJobCommitDateEnd"
                      ref="reBcRetrieveJobCommitDateEnd"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-calendar-check-o"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เลขที่เอกสารใบงานต้นทาง:</label>
                  <textarea
                    v-model="reBcTransferJobNumber"
                    type="text"
                    class="form-control"
                    rows="1"
                    placeholder="ค้นหาจาก เลขที่เอกสารใบงานต้นทาง"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เลขที่เอกสารใบงานปลายทาง:</label>
                  <textarea
                    v-model="reBcChildJobs"
                    type="text"
                    class="form-control"
                    rows="1"
                    placeholder="ค้นหาจาก เลขที่เอกสารใบงานปลายทาง"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทเอกสาร:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBcTransferJobTypeCode'"
                    :name="'reBcTransferJobTypeCode'"
                    :select2-options="reBcTransferJobTypeCodeOptions"
                    v-model="reBcTransferJobTypeCode"
                    ref="reBcTransferJobTypeCodeSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ต้นทาง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBcOrigin'"
                    :name="'reBcOrigin'"
                    :select2-options="reBcOriginOptions"
                    v-model="reBcOrigin"
                    multiple
                    ref="reBcOriginSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reBcOrigin"
                    :multiple="true"
                    :options="reBcOriginOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ปลายทาง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBcDestination'"
                    :name="'reBcDestination'"
                    :select2-options="reBcDestinationOptions"
                    v-model="reBcDestination"
                    multiple
                    ref="reBcDestinationSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reBcDestination"
                    :multiple="true"
                    :options="reBcDestinationOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>รถขนส่ง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBcTransitId'"
                    :name="'reBcTransitId'"
                    :select2-options="reBcTransitIdOptions"
                    v-model="reBcTransitId"
                    multiple
                    ref="reBcTransitIdSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reBcTransitId"
                    :multiple="true"
                    :load-options="LoadreBcTransitIdOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ชื่อผู้ติดต่อ:</label>
                  <textarea
                    v-model="reBcTransitContact"
                    type="text"
                    class="form-control"
                    rows="1"
                    placeholder="ค้นหาจาก ชื่อผู้ติดต่อ"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>เบอร์โทร:</label>
                  <textarea
                    v-model="reBcTransitContactTel"
                    type="text"
                    class="form-control"
                    rows="1"
                    placeholder="ค้นหาจาก เบอร์โทร"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะต้นทาง:</label>
                  <!-- <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBcTransferJobStatusCode'"
                    :name="'reBcTransferJobStatusCode'"
                    :select2-options="reBcTransferJobStatusCodeOptions"
                    v-model="reBcTransferJobStatusCode"
                    multiple
                    ref="reBcTransferJobStatusCodeSelect2"
                  ></select2> -->
                  <treeselect
                    v-model="reBcTransferJobStatusCode"
                    :multiple="true"
                    :options="reBcTransferJobStatusCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>สถานะปลายทาง:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBcCompletedJob'"
                    :name="'reBcCompletedJob'"
                    :select2-options="reBcCompletedJobOptions"
                    v-model="reBcCompletedJob"
                    ref="reBcCompletedJobSelect2"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ผลการส่ง:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'reBcResult'"
                    :name="'reBcResult'"
                    :select2-options="reBcResultOptions"
                    v-model="reBcResult"
                    ref="reBcResultSelect2"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button class="btn btn-outline-primary" @click="ExportBrandCount($event)" type="submit">
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="brandCountTable"
                style="width:100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="28">
                      ข้อมูล ณ วันที่ {{ reBcDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ลำดับ</th>
                    <th class="all text-center">วันที่ส่ง</th>
                    <th class="all text-center">วันที่รับ</th>
                    <th class="all text-center">ระยะเวลาขนส่ง</th>
                    <th class="all text-center">เลขที่เอกสารใบงานต้นทาง</th>
                    <th class="all text-center">เลขที่เอกสารใบงานปลายทาง</th>
                    <th class="all text-center">ประเภทเอกสาร</th>
                    <th class="all text-center">รหัสต้นทาง</th>
                    <th class="all text-center">ชื่อต้นทาง</th>
                    <th class="all text-center">รหัสปลายทาง</th>
                    <th class="all text-center">ชื่อปลายทาง</th>
                    <th class="all text-center">SINGHA</th>
                    <th class="all text-center">LEO</th>
                    <th class="all text-center">ASAHI</th>
                    <th class="all text-center">CARLSBERG</th>
                    <th class="all text-center">KRONENBOURG</th>
                    <th class="all text-center">SNOWY</th>
                    <th class="all text-center">KOPPER</th>
                    <th class="all text-center">OTHERS</th>
                    <th class="all text-center">ท่อ CO2</th>
                    <th class="all text-center">รวม</th>
                    <th class="all text-center">รถขนส่ง</th>
                    <th class="all text-center">ชื่อผู้ติดต่อ</th>
                    <th class="all text-center">เบอร์โทร</th>
                    <th class="all text-center">สถานะต้นทาง</th>
                    <th class="all text-center">สถานะปลายทาง</th>
                    <th class="all text-center">ผลการส่ง</th>
                    <th class="all text-center">จำนวนขาดส่ง</th>
                    <th class="all text-center"></th>
                  </tr>
                </thead>
                <tfoot v-if="isShowFooter">
                  <tr>
                    <th class="text-center" colspan="10"></th>
                    <th class="text-center" colspan="1">รวมทั้งหมด</th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestSingha }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestLeo }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestAsahi }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestCarlsberg }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestKronenbourg }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestSnowy }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestKopper }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestOther }}
                    </th>
                    <th class="text-center" colspan="1">
                      {{ reBcTotalDestCo2 }}
                    </th>
                    <th class="text-center" colspan="1">{{ reBcTotalDest }}</th>
                    <th class="text-center" colspan="7"></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Actions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="barcodeModal" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายการบาร์โค้ดขาดส่ง">
      <i class="la la-search"></i>
    </a>
  </div>`,
  methods: {
    barcodeModal: function() {
      router.push({
        path: `/Report/BrandCount/BarCode/${this.data.transferJobId}`,
      });
    },
  },
});

let ActionsTransferJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.data.transferJobNumber,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});

let ActionsChildJob = Vue.extend({
  template: `
    <a href="#" @click.prevent="openChildJob" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="รายละเอียดเอกสารใบงานต้นทาง">
      <i class="la la-external-link"></i>
    </a>
  `,
  methods: {
    openChildJob: function() {
      //get JobID by TransferJob
      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
      });

      axios
        .post("/Api/Jobs/GetJobId", {
          JobNumber: this.childJobs,
        })
        .then(function(response) {
          if (response.status == 200) {
            window.open("/Jobs/Edit/" + response.data, "_blank");
          } else {
            // always executed
            KTApp.unblockPage();
            Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล", "error");
          }
        })
        .catch(function(error) {
          // always executed
          KTApp.unblockPage();
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;

    return {
      reBcIsInitial: true,
      isShowFooter: false,
      reBcDateReq: null,
      reBcTransferJobCommitDateStart: null,
      reBcTransferJobCommitDateEnd: null,
      reBcRetrieveJobCommitDateStart: null,
      reBcRetrieveJobCommitDateEnd: null,
      reBcTransferJobNumber: null,
      reBcChildJobs: null,
      reBcTransferJobTypeCode: null,
      reBcOrigin: [],
      reBcDestination: [],
      reBcTransitId: [],
      reBcTransitContact: null,
      reBcTransitContactTel: null,
      reBcTransferJobStatusCode: [],
      reBcCompletedJob: null,
      reBcResult: null,

      reBcTotalDestSingha: null,
      reBcTotalDestLeo: null,
      reBcTotalDestAsahi: null,
      reBcTotalDestCarlsberg: null,
      reBcTotalDestKronenbourg: null,
      reBcTotalDestSnowy: null,
      reBcTotalDestKopper: null,
      reBcTotalDestOther: null,
      reBcTotalDestCo2: null,
      reBcTotalDest: null,

      reBcTransferJobTypeCodeOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกประเภทเอกสาร",
        allowClear: true,
        data: [
          {
            id: "JOB_TYPE_TRANSFER_TO_AGENT",
            text: "ส่งสินค้าไปยังตัวแทน ฯ",
            data: null,
          },
          {
            id: "JOB_TYPE_RETURN",
            text: "ส่งสินค้า/ทรัพย์สินคืนต้นทาง",
            data: null,
          },
        ],
        // minimumResultsForSearch: -1,
        // placeholder: "กรุณาเลือกประเภทเอกสาร",
        // allowClear: true,
        // ajax: {
        //   url: "/Api/Variables/Options?search=JOB_TYPE",
        //   data: function(params) {
        //     var query = {
        //       search: params.term,
        //       page: params.page || 1
        //     };
        //     return query;
        //   },
        //   processResults: function(data, params) {
        //     return {
        //       results: data.results,
        //       pagination: {
        //         more: data.more
        //       }
        //     };
        //   },
        //   transport: function(params, success, failure) {
        //     params.beforeSend = function(request) {
        //       request.setRequestHeader(
        //         "Authorization",
        //         "Bearer " + self.$root.user.access_token
        //       );
        //     };
        //     var $request = $.ajax(params);
        //     $request.then(success);
        //     $request.fail(failure);
        //     return $request;
        //   }
        // }
      },
      reBcOriginOptions: [],
      // reBcOriginOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกต้นทาง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2PlantAgent",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcDestinationOptions: [],
      // reBcDestinationOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกปลายทาง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Report/Select2PlantAgent",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcTransitIdOptions: [],
      // reBcTransitIdOptions: {
      //   placeholder: "กรุณาเลือกรถขนส่ง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Transport/Select2Transport",
      //     type: "post",
      //     dataType: "json",
      //     contentType: "application/json",
      //     data: function(params) {
      //       var query = {
      //         showVendorTransport: true,
      //         agentCodes: [],
      //         isShowPickup: true,
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return JSON.stringify(query);
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcTransferJobStatusCodeOptions: [],
      // reBcTransferJobStatusCodeOptions: {
      //   minimumResultsForSearch: -1,
      //   placeholder: "กรุณาเลือกสถานะต้นทาง",
      //   allowClear: true,
      //   ajax: {
      //     url: "/Api/Variables/Options?search=JOB_STATUS",
      //     data: function(params) {
      //       var query = {
      //         search: params.term,
      //         page: params.page || 1,
      //       };
      //       return query;
      //     },
      //     processResults: function(data, params) {
      //       return {
      //         results: data.results,
      //         pagination: {
      //           more: data.more,
      //         },
      //       };
      //     },
      //     transport: function(params, success, failure) {
      //       params.beforeSend = function(request) {
      //         request.setRequestHeader(
      //           "Authorization",
      //           "Bearer " + self.$root.user.access_token
      //         );
      //       };
      //       var $request = $.ajax(params);
      //       $request.then(success);
      //       $request.fail(failure);
      //       return $request;
      //     },
      //   },
      // },
      reBcCompletedJobOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกสถานะปลายทาง",
        allowClear: true,
        data: [
          {
            id: 1,
            text: "ดำเนินการเรียบร้อย",
            data: null,
          },
          {
            id: 0,
            text: "ระหว่างดำเนินการ",
            data: null,
          },
        ],
      },
      reBcResultOptions: {
        minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกผลการส่ง",
        allowClear: true,
        data: [
          {
            id: "ส่งครบ",
            text: "ส่งครบ",
            data: null,
          },
          {
            id: "ขาดส่ง",
            text: "ขาดส่ง",
            data: null,
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;

      self.reBcTransferJobCommitDateStart = null;
      self.reBcTransferJobCommitDateEnd = null;
      self.reBcRetrieveJobCommitDateStart = null;
      self.reBcRetrieveJobCommitDateEnd = null;
      self.reBcTransferJobNumber = null;
      self.reBcChildJobs = null;
      self.reBcTransferJobTypeCode = null;
      self.reBcOrigin = [];
      self.reBcDestination = [];
      self.reBcTransitId = [];
      self.reBcTransitContact = null;
      self.reBcTransitContactTel = null;
      self.reBcTransferJobStatusCode = [];
      self.reBcCompletedJob = null;
      self.reBcResult = null;

      $("#reBcTransferJobTypeCode")
        .val("")
        .trigger("change");

      $("#reBcOrigin")
        .val("")
        .trigger("change");

      $("#reBcDestination")
        .val("")
        .trigger("change");

      $("#reBcTransitId")
        .val("")
        .trigger("change");

      $("#reBcTransferJobStatusCode")
        .val("")
        .trigger("change");

      $("#reBcCompletedJob")
        .val("")
        .trigger("change");

      $("#reBcResult")
        .val("")
        .trigger("change");
    },
    formSubmit: function(e) {
      let self = this;

      if (
        !self.reBcTransferJobCommitDateStart &&
        self.reBcTransferJobCommitDateEnd
      ) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่ส่ง(เริ่มต้น)", "warning");
        return false;
      } else if (
        self.reBcTransferJobCommitDateStart &&
        !self.reBcTransferJobCommitDateEnd
      ) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่ส่ง(สิ้นสุด)", "warning");
        return false;
      }

      if (
        !self.reBcRetrieveJobCommitDateStart &&
        self.reBcRetrieveJobCommitDateEnd
      ) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับ(เริ่มต้น)", "warning");
        return false;
      } else if (
        self.reBcRetrieveJobCommitDateStart &&
        !self.reBcRetrieveJobCommitDateEnd
      ) {
        Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่รับ(สิ้นสุด)", "warning");
        return false;
      }

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      e.preventDefault();
      var table = $("#brandCountTable").DataTable();
      table.draw();
    },
    LoadreBcOriginOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2PlantAgent", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBcOriginOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBcDestinationOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Report/Select2PlantAgent", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBcDestinationOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadreBcTransitIdOptions({ action, searchQuery, callback }) {
      var self = this;
      self.reBcTransitIdOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Transport/Select2Transport", {
            showVendorTransport: true,
            agentCodes: [],
            isShowPickup: true,
            page: 1,
            search: searchQuery,
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.reBcTransitIdOptions = [];
              data.forEach((element) => {
                self.reBcTransitIdOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.reBcTransitIdOptions);
          });
      }
    },
    LoadreBcTransferJobStatusCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Variables/Options?search=JOB_STATUS", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.reBcTransferJobStatusCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    ClearAfterselect: function(){
      $(`[class="vue-treeselect__input"]`).val("");
    },
    ExportBrandCount: function (e) {
      e.preventDefault();
      let self = this;

      // if (
      //   !self.reMmBarcode &&
      //   !self.reMmDepartmentMaterialCode &&
      //   !self.reMmNFCCode &&
      //   !self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกเงื่อนไขรายงาน", "warning");
      //   return false;
      // }

      // if (!self.reMmTransactionDateStart && self.reMmTransactionDateEnd) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(เริ่มต้น)", "warning");
      //   return false;
      // } else if (
      //   self.reMmTransactionDateStart &&
      //   !self.reMmTransactionDateEnd
      // ) {
      //   Swal.fire("เกิดข้อผิดพลาด", "กรุณาเลือกวันที่(สิ้นสุด)", "warning");
      //   return false;
      // }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportBrandCount",
        responseType: "arraybuffer",
        data: {
          IsInitial: self.reBcIsInitial,
            TransferJobCommitDateStart:
              self.reBcTransferJobCommitDateStart != null
                ? self.reBcTransferJobCommitDateStart.format("DD/MM/YYYY")
                : self.reBcTransferJobCommitDateStart,
            TransferJobCommitDateEnd:
              self.reBcTransferJobCommitDateEnd != null
                ? self.reBcTransferJobCommitDateEnd.format("DD/MM/YYYY")
                : self.reBcTransferJobCommitDateEnd,
            RetrieveJobCommitDateStart:
              self.reBcRetrieveJobCommitDateStart != null
                ? self.reBcRetrieveJobCommitDateStart.format("DD/MM/YYYY")
                : self.reBcRetrieveJobCommitDateStart,
            RetrieveJobCommitDateEnd:
              self.reBcRetrieveJobCommitDateEnd != null
                ? self.reBcRetrieveJobCommitDateEnd.format("DD/MM/YYYY")
                : self.reBcRetrieveJobCommitDateEnd,
            TransferJobNumber: self.reBcTransferJobNumber,
            ChildJobs: self.reBcChildJobs,
            TransferJobTypeCode: self.reBcTransferJobTypeCode,
            OriginCode: self.reBcOrigin,
            DestinationCode: self.reBcDestination,
            TransitId: self.reBcTransitId,
            TransitContact: self.reBcTransitContact,
            TransitContactTel: self.reBcTransitContactTel,
            TransferJobStatusCode: self.reBcTransferJobStatusCode,
            CompletedJob: self.reBcCompletedJob,
            Result: self.reBcResult,
        },
      })
        .then(function (response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = decodeURIComponent(filename);
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function (error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function () {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    HiddenJobTransferToAgent: function (JobTypeCode){
      var showStatus = true;
      if(this.$root.canShow(['super_admin','MANAGE_MASTER','JOB_ADMIN_BORROW_APPROVE']) == true){
        showStatus = true;
      }else{
        if(this.$root.user.profile.profile_type == "COMPANY_PROFILE_TYPE_AGENT"){
          if(JobTypeCode == "JOB_TYPE_TRANSFER_TO_AGENT"){
            showStatus = false;
          }else{
            showStatus = true;
          }
        }else{
          showStatus = true;
        }
      }
      return showStatus
    },HiddenJobReturn: function (JobTypeCode){
      var showStatus = true;
      if(this.$root.canShow(['super_admin','MANAGE_MASTER','JOB_ADMIN_BORROW_APPROVE']) == true){
        showStatus = true;
      }else{
        if(this.$root.user.profile.profile_type == "COMPANY_PROFILE_TYPE_AGENT"){
          if(JobTypeCode == "JOB_TYPE_RETURN"){
            showStatus = false;
          }else{
            showStatus = true;
          }
        }else{
          showStatus = true;
        }
      }
      return showStatus
    }
  },
  async mounted() {
    let self = this;

    self.LoadreBcOriginOptions();
    self.LoadreBcDestinationOptions();
    self.LoadreBcTransferJobStatusCodeOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reBcTransferJobCommitDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.reBcTransferJobCommitDateStart)
      .datepicker(
        "update",
        !!self.reBcTransferJobCommitDateStart
          ? self.reBcTransferJobCommitDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBcTransferJobCommitDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBcTransferJobCommitDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateEnd = moment().endOf('month');
    $(self.$refs.reBcTransferJobCommitDateEnd)
      .datepicker(
        "update",
        !!self.reBcTransferJobCommitDateEnd
          ? self.reBcTransferJobCommitDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBcTransferJobCommitDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBcRetrieveJobCommitDateStart).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reMmTransactionDateEnd = moment().endOf('month');
    $(self.$refs.reBcRetrieveJobCommitDateStart)
      .datepicker(
        "update",
        !!self.reBcRetrieveJobCommitDateStart
          ? self.reBcRetrieveJobCommitDateStart.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBcRetrieveJobCommitDateStart =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reBcRetrieveJobCommitDateEnd).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reMmTransactionDateEnd = moment().endOf('month');
    $(self.$refs.reBcRetrieveJobCommitDateEnd)
      .datepicker(
        "update",
        !!self.reBcRetrieveJobCommitDateEnd
          ? self.reBcRetrieveJobCommitDateEnd.format("DD/MM/YYYY")
          : null
      )
      .on("changeDate", function(e) {
        self.reBcRetrieveJobCommitDateEnd =
          e.dates.length != 0 ? moment(e.date) : null;
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#brandCountTable");
    //begin first table
    table
      .DataTable({
        autoWidth: true,
        scrollY: "100%",
        scrollX: true,
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Report/BrandCount",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            self.isShowFooter = false;

            let jsonSearch = {
              IsInitial: self.reBcIsInitial,
              TransferJobCommitDateStart:
                self.reBcTransferJobCommitDateStart != null
                  ? self.reBcTransferJobCommitDateStart.format("DD/MM/YYYY")
                  : self.reBcTransferJobCommitDateStart,
              TransferJobCommitDateEnd:
                self.reBcTransferJobCommitDateEnd != null
                  ? self.reBcTransferJobCommitDateEnd.format("DD/MM/YYYY")
                  : self.reBcTransferJobCommitDateEnd,
              RetrieveJobCommitDateStart:
                self.reBcRetrieveJobCommitDateStart != null
                  ? self.reBcRetrieveJobCommitDateStart.format("DD/MM/YYYY")
                  : self.reBcRetrieveJobCommitDateStart,
              RetrieveJobCommitDateEnd:
                self.reBcRetrieveJobCommitDateEnd != null
                  ? self.reBcRetrieveJobCommitDateEnd.format("DD/MM/YYYY")
                  : self.reBcRetrieveJobCommitDateEnd,
              TransferJobNumber: self.reBcTransferJobNumber,
              ChildJobs: self.reBcChildJobs,
              TransferJobTypeCode: self.reBcTransferJobTypeCode,
              OriginCode: self.reBcOrigin,
              DestinationCode: self.reBcDestination,
              TransitId: self.reBcTransitId,
              TransitContact: self.reBcTransitContact,
              TransitContactTel: self.reBcTransitContactTel,
              TransferJobStatusCode: self.reBcTransferJobStatusCode,
              CompletedJob: self.reBcCompletedJob,
              Result: self.reBcResult,
            };
            return JSON.stringify($.extend(d, jsonSearch));
          },
        },
        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
  			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[1, "desc"]],
        columns: [
          {
            data: "transferJobCommitDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              var t = table.DataTable();
              var page = t.page.info().start + 1;
              return page + meta.row;
            },
          },
          {
            data: "transferJobCommitDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.transferJobCommitDateString;
            },
          },
          {
            data: "retrieveJobCommitDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.retrieveJobCommitDateString;
            },
          },
          {
            data: "transferMinutes",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.transferMinutesString;
            },
          },
          {
            data: "transferJobNumber",
            className: "text-center",
            render: function(data, type, full, meta) {
              var jobStatus = self.HiddenJobTransferToAgent(full.transferJobTypeCode);
              if(jobStatus){
                return data + '<div class="actionsTransferJob"></div>';
              }else{
                return data;
              }
            },
          },
          {
            data: "childJobs",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data != null) {
                var str = "";
                for (var i = 0; i < full.childJobsList.length; i++) {
                  var jobStatus = self.HiddenJobReturn(full.transferJobTypeCode);
                  if(jobStatus){
                    str += full.childJobsList[i] + '<div class="actionsChildJob" data-childJobs="' + full.childJobsList[i] +'"></div><br>';
                  }else{
                    str += full.childJobsList[i];
                  }
                  
                }
                return str;
                //return data+'<div class="actionsChildJob"></div>';
              } else {
                return "";
              }
            },
          },
          { data: "transferJobTypeName", className: "text-center" },
          { data: "originCode", className: "text-center" },
          { data: "originName", className: "text-center" },
          { data: "destinationCode", className: "text-center" },
          { data: "destinationName", className: "text-center" },
          {
            data: "destSinghaAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destLeoAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destAsahiAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destCarlsbergAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destKronenbourgAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destSnowyAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destKopperAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destOtherAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destCo2Amount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "destAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "transitCompanyNameString",
            className: "text-center",
            // render : function (data, type, full, meta){
            //   if(full.pickupAtOrigin){
            //     return "รับเอง"
            //   }
            //   else if(full.transitCompanyName != null){
            //     return full.transitCompanyName +" ("+full.transitCarReg+")";
            //   }
            //   else{
            //     return "";
            //   }
            //}
          },
          { data: "transitContactFullName", className: "text-center" },
          { data: "transitContactTel", className: "text-center" },
          { data: "transferJobStatusName", className: "text-center" },
          {
            data: "completedJob",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data === 1) {
                return "ดำเนินการเรียบร้อย";
              } else {
                return "ระหว่างดำเนินการ";
              }
            },
          },
          { data: "result", className: "text-center" },
          {
            data: "diffAmount",
            className: "text-center",
            render: function(data, type, full, meta) {
              if (data !== 0) {
                return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              } else {
                return "";
              }
            },
          },
          {
            data: "transferJobId",
            className: "text-center",
            orderable: false,
            render: function(data, type, full, meta) {
              if (full.diffAmount !== 0) {
                return '<div class="action"></div>';
              } else {
                return "";
              }
            },
          },
        ],
        rowCallback: function(row, data, index) {
          if (data.childJobsList.length > 0) {
            $(row).prop("rowspan", data.childJobsList.length);

            // $.each( data.childJobsList, function( key, value ) {

            //   //$(row).find('td:eq(ุ6)').row html( '<b>A</b>' );

            // });
          }

          if (data.transferJobStatusCode === "JOB_STATUS_SUCCESS") {
            $(row)
              .find("td:eq(24)")
              .css("color", "#00B050");
          }
          if (data.completedJob === 1) {
            $(row)
              .find("td:eq(25)")
              .css("color", "#00B050");
          }
          if (data.completedJob === 0) {
            $(row)
              .find("td:eq(25)")
              .css("color", "#FFC000");
          }
          if (data.result === "ส่งครบ") {
            $(row)
              .find("td:eq(26)")
              .css("color", "#00B050");
          }
          if (data.result === "ขาดส่ง") {
            $(row)
              .find("td:eq(26)")
              .css("color", "#FF0000");
          }
          if (data.diffAmount !== 0) {
            $(row)
              .find("td:eq(27)")
              .css("color", "#FF0000");
          }
        },
        drawCallback: function(settings) {
          self.reBcIsInitial = false;
          self.reBcDateReq = moment().format("DD/MM/YYYY h:mm a");

          var allPage = table.DataTable().page.info().pages;
          var currentPage = table.DataTable().page.info().page + 1;

          self.isShowFooter = false;
          self.isShowFooter = null;
          self.reBcTotalDestLeo = null;
          self.reBcTotalDest = null;
          self.reBcTotalDestAsahi = null;
          self.reBcTotalDestCarlsberg = null;
          self.reBcTotalDestCo2 = null;
          self.reBcTotalDestKopper = null;
          self.reBcTotalDestKronenbourg = null;
          self.reBcTotalDestLeo = null;
          self.reBcTotalDestOther = null;
          self.reBcTotalDestSingha = null;
          self.reBcTotalDestSnowy = null;

          if (allPage == currentPage) {
            self.isShowFooter = true;
            self.reBcTotalDestLeo =
              settings.json.data[0].total.destLeoAmountTotal !== 0
                ? settings.json.data[0].total.destLeoAmountTotal
                : "-";
            self.reBcTotalDest =
              settings.json.data[0].total.destAmountTotal !== 0
                ? settings.json.data[0].total.destAmountTotal
                : "-";
            self.reBcTotalDestAsahi =
              settings.json.data[0].total.destAsahiAmountTotal !== 0
                ? settings.json.data[0].total.destAsahiAmountTotal
                : "-";
            self.reBcTotalDestCarlsberg =
              settings.json.data[0].total.destCarlsbergAmountTotal !== 0
                ? settings.json.data[0].total.destCarlsbergAmountTotal
                : "-";
            self.reBcTotalDestCo2 =
              settings.json.data[0].total.destCo2AmountTotal !== 0
                ? settings.json.data[0].total.destCo2AmountTotal
                : "-";
            self.reBcTotalDestKopper =
              settings.json.data[0].total.destKopperAmountTotal !== 0
                ? settings.json.data[0].total.destKopperAmountTotal
                : "-";
            self.reBcTotalDestKronenbourg =
              settings.json.data[0].total.destKronenbourgAmountTotal !== 0
                ? settings.json.data[0].total.destKronenbourgAmountTotal
                : "-";
            self.reBcTotalDestLeo =
              settings.json.data[0].total.destLeoAmountTotal !== 0
                ? settings.json.data[0].total.destLeoAmountTotal
                : "-";
            self.reBcTotalDestOther =
              settings.json.data[0].total.destOtherAmountTotal !== 0
                ? settings.json.data[0].total.destOtherAmountTotal
                : "-";
            self.reBcTotalDestSingha =
              settings.json.data[0].total.destSinghaAmountTotal !== 0
                ? settings.json.data[0].total.destSinghaAmountTotal
                : "-";
            self.reBcTotalDestSnowy =
              settings.json.data[0].total.destSnowyAmountTotal !== 0
                ? settings.json.data[0].total.destSnowyAmountTotal
                : "-";

            //$.fn.dataTable.tables( {visible: true, api: true} ).columns.adjust();
          }
        },
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.form, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.form);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        // var t = table.DataTable();
        // var page = t.page.info().start + 1;
        // t.column(0, {}).nodes().each( function (cell, i) {
        //     cell.innerHTML = i+page;
        // } );
        $(".action").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new Actions({ data: { data }, parent: self }).$mount(el);
          }
        });

        $(".actionsTransferJob").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new ActionsTransferJob({ data: { data }, parent: self }).$mount(el);
          }
        });

        $(".actionsChildJob").each(function(i, el) {
          // console.log(i);
          var childJobs = el.getAttribute("data-childJobs");
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            new ActionsChildJob({ data: { childJobs }, parent: self }).$mount(
              el
            );
          }
        });
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/BrandCount.vue